import { useState, useEffect } from "react";
import {
  getSessionValue,
  setSessionValue,
  clearSessionValue,
  upsertTag,
  uuidMapping,
} from "../helper";
import { geoLocationService } from "../../../../../_services/geoLocation.service";

export const useLocationFilter = (talentFilter, talentData) => {

  const [zipValue, setZipValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [radiusValue, setRadiusValue] = useState("");
  const [locationType, setLocationType] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedStateName, setSelectedStateName] = useState("");

  useEffect(() => {
    if (!talentFilter?.location) return;

    const { type, value } = talentFilter.location;

    if (type === "state") {
      setSelectedState(value);
      setLocationType("state");

      talentData?.provinces?.forEach(p => {
        if (p.uuid == value) setSelectedStateName(p.name);
      });
    }

    if (type === "city_state") {
      const [city, state] = value.split("::");
      setSelectedState(state);
      setCityValue(city);
      setLocationType("city_state");

      talentData?.provinces?.forEach(p => {
        if (p.uuid == state) setSelectedStateName(p.name);
      });
    }

    if (type === "radius") {
      setLocationType("radius");
      setZipValue(getSessionValue("zipCode") || "");
      setRadiusValue(value || "");
    }
  }, []);

  useEffect(() => {
    if (!talentFilter || Object.keys(talentFilter).length === 0) {
      clearLocation();
    }
  }, [talentFilter]);

  const clearLocation = () => {
    setZipValue("");
    setCityValue("");
    setRadiusValue("");
    setLocationType("");
    setSelectedState("");
    setSelectedStateName("");

    clearSessionValue("Lat");
    clearSessionValue("Long");
    clearSessionValue("zipCode");
  };

  const onZipChange = async (value) => {
    if (value?.length === 5) {
      const res = await geoLocationService.getCoordinatesFromZipCode(value);
      setSessionValue("Lat", res.results[0]?.geometry?.location.lat);
      setSessionValue("Long", res.results[0]?.geometry?.location.lng);
    }

    setZipValue(value);
    setLocationType("radius");
    setCityValue("");
    setSelectedState("");
    setSelectedStateName("");
  };

  const onRadiusChange = (e) => {
    setRadiusValue(e.target.value);
    setLocationType("radius");
    setCityValue("");
    setSelectedState("");
    setSelectedStateName("");
  };

  const onStateChange = (value, label) => {
    setSelectedState(value);
    setSelectedStateName(label.children);
    setLocationType(cityValue ? "city_state" : "state");

    setZipValue("");
    setRadiusValue("");
    clearSessionValue("Lat");
    clearSessionValue("Long");
    clearSessionValue("zipCode");
  };

  const onCityChange = (e) => {
    setCityValue(e.target.value);
    setLocationType(e.target.value ? "city_state" : selectedState ? "state" : "");

    setRadiusValue("");
    setZipValue("");
    clearSessionValue("Lat");
    clearSessionValue("Long");
    clearSessionValue("zipCode");
  };

  const addLocationFilter = (talentFilter, talentFilterTags) => {
    if (!locationType) return null;

    const locationObj = {
      type: locationType,
      value:
      locationType === "radius"
        ? radiusValue
        : locationType === "state"
        ? selectedState
        : `${cityValue}::${selectedState}`,
    };

    const finalLocation =
      locationType === "radius"
      ? {
        ...locationObj,
        lat: parseFloat(getSessionValue("Lat")),
        long: parseFloat(getSessionValue("Long")),
      }
      : locationObj;

    let tags = talentFilterTags;

    if (locationType === "radius") {
      tags = upsertTag(tags, uuidMapping.radius, {
        zipValue,
        radiusValue: finalLocation.value,
      });
    } 
    else if (locationType === "state") {
      tags = upsertTag(tags, "state", { stateValue: selectedStateName });
    } 
    else {
      tags = upsertTag(tags, "city", {
        stateValue: selectedStateName,
        cityValue,
      });
    }

    return { location: finalLocation, tags };
  };

  return {
    zipValue,
    cityValue,
    radiusValue,
    locationType,
    selectedState,
    selectedStateName,
    onZipChange,
    onRadiusChange,
    onStateChange,
    onCityChange,
    addLocationFilter,
    clearLocation
  };
};
